module.exports = __webpack_public_path__ + "clipboard-91cb25a42b442eafb1f0.svg";